// class Collection{constructor(){this.selectors={section:".facest-filters-section",toolbar:".m-collection-toolbar",cols:[".m-toolbar--column-switcher button"],productContainer:"[data-product-container]",loadMoreBtn:"[data-load-more]",sidebar:".m-sidebar",sidebarContent:".m-sidebar--content",openSidebar:".m-sidebar--open",closeSidebar:".m-sidebar--close",filtersWrapper:".m-filter--wrapper"},this.mobileSortingSelectors={openSorting:".m-sortby--open",closeSorting:".m-sortby-mobile--close",sortingWrapper:".m-sortby-mobile--wrapper",sortingList:".m-sortby-mobile--content"},this.sectionId="",this.isDesignMode=MinimogSettings.design_mode,this.currentPage=1,this.paginationType,this.totalPages,this.totalProducts,this.infiniteLoadingObserver,this.showColSwitchers,this.cachedCol,this.initialCol,this.activeCol,this.STORAGE_KEY="gridColumnViews",this.MAX_COL_BY_SCREEN_SIZE={mobile:2,tablet:4,desktop:5},this.enableFilters,this.enableSorting,this.filtersType,this.filtersPosition,this.accordions,this.sideEffectEventsAdded=!1}init=()=>{this.domNodes=queryDomNodes(this.selectors),this.mbSortingNodes=queryDomNodes(this.mobileSortingSelectors),this.setData(),this.initGridView(),this.initFilters(),this.initMobileSorting(),this.initProducts(),this.sideEffectEventsAdded=!0,MinimogEvents.subscribe("ON_PRODUCT_LIST_UPDATED",(()=>refreshProductReview())),this.handleStickyToolbar(),document.addEventListener("matchMobile",(()=>this.handleStickyToolbar())),document.addEventListener("unmatchMobile",(()=>this.handleStickyToolbar()))};setData=()=>{const{section:t,productContainer:e}=this.domNodes;this.sectionId=t.dataset.sectionId,this.paginationType=t.dataset.paginationType,this.totalPages=e&&Number(e.dataset.totalPages),this.view=t.dataset.view,this.activeCol=null,this.currentPage=1,this.initialCol=Number(t.dataset.initialColumn),this.cachedCol=Number(window.localStorage.getItem(this.STORAGE_KEY))||this.initialCol,this.showColSwitchers="true"===t.dataset.showColSwitchers,this.enableFilters="true"===t.dataset.enableFilters,this.enableSorting="true"===t.dataset.enableSorting,this.filtersType=t.dataset.filtersType,this.filtersPosition=t.dataset.filtersPosition};initGridView=()=>{this.toggleView(this.isDesignMode?this.initialCol:this.cachedCol),this.updateViewByScreen(),addEventDelegate({selector:this.selectors.cols[0],context:this.domNodes.toolbar,handler:(t,e)=>this.toggleView(Number(e.dataset.column))}),this.initLoadMore(),this.sideEffectEventsAdded||window.addEventListener("resize",debounce(this.updateViewByScreen,500))};initFilters=()=>{if(!this.enableFilters)return;const{sidebar:t,openSidebar:e,closeSidebar:i}=this.domNodes;window.requestAnimationFrame(this.initAccordions),e.addEventListener("click",this.openSidebarFilter),i.addEventListener("click",this.closeSidebarFilter),t.addEventListener("click",(e=>e.target===t&&this.closeSidebarFilter()))};initMobileSorting=()=>{if(!this.enableSorting)return;const{openSorting:t,closeSorting:e,sortingWrapper:i}=this.mbSortingNodes;t.addEventListener("click",this.openMobileSorting),e.addEventListener("click",this.closeMobileSorting),i.addEventListener("click",(t=>t.target===i&&this.closeMobileSorting()))};openMobileSorting=()=>{const{sortingWrapper:t,sortingList:e}=this.mbSortingNodes;t.style.display="block",window.requestAnimationFrame((()=>{t.style.setProperty("--m-bg-opacity","0.5"),e.style.setProperty("--m-translate-y","0")}))};closeMobileSorting=t=>{const{sortingWrapper:e,sortingList:i}=this.mbSortingNodes;e.style.setProperty("--m-bg-opacity","0"),i.style.setProperty("--m-translate-y","100%"),setTimeout((()=>e.style.setProperty("display","none")),300)};initAccordions=()=>{this.accordions&&this.accordions.destroy();const{filtersWrapper:t}=this.domNodes;t.classList.remove("acc-initialized"),this.accordions=new MinimogLibs.Accordion(t,{presetContentHeight:window.innerWidth>1280&&"fixed"!==this.filtersPosition,callback:()=>t.style.setProperty("opacity","1")})};openSidebarFilter=()=>{const{sidebar:t,sidebarContent:e,section:i}=this.domNodes;t.style.display="block",window.requestAnimationFrame((()=>{t.style.setProperty("--m-bg-opacity","0.5"),e.style.setProperty("--m-translate-x","0"),this.accordions&&this.accordions.setContentHeight()})),i.classList.add("sidebar-open")};closeSidebarFilter=()=>{const{sidebar:t,sidebarContent:e,section:i}=this.domNodes;i.classList.remove("sidebar-open"),(window.innerWidth<1280||"fixed"===t.dataset.type)&&(e.style.setProperty("--m-translate-x","-100%"),t.style.removeProperty("--m-bg-opacity"),setTimeout((()=>t.style.removeProperty("display")),300))};toggleView=t=>{if(!t||"search"===this.view)return;const{cols:e,productContainer:i}=this.domNodes;if(!i)return;const s=i.querySelectorAll("responsive-image");s&&s.length>0&&s.forEach((t=>{t.disconnectedCallback(),t.connectedCallback()}));const o=this.activeCol||this.initialCol;this.showColSwitchers&&(e[o-1].classList.remove("active"),e[t-1].classList.add("active")),i.classList.remove(`m-cols-${o}`),i.classList.add(`m-cols-${t}`),window.localStorage.setItem(this.STORAGE_KEY,t),this.activeCol=t};updateViewByScreen=()=>{if(1===this.activeCol)return;const t=this.getDeviceByScreenSize(),e=this.MAX_COL_BY_SCREEN_SIZE[t];e<this.activeCol&&this.toggleView(e)};getDeviceByScreenSize=()=>window.innerWidth<768?"mobile":window.innerWidth<1024?"tablet":"desktop";initLoadMore=()=>{if("paginate"===this.paginationType||this.totalPages<=1||"search"===this.view)return;const{loadMoreBtn:t}=this.domNodes;t.addEventListener("click",this.loadMoreProducts),"infinite"===this.paginationType&&(this.infiniteLoadingObserver=new IntersectionObserver((t=>{t.forEach((t=>{1===t.intersectionRatio&&this.loadMoreProducts()}))}),{threshold:1}),this.infiniteLoadingObserver.observe(t))};loadMoreProducts=()=>{const t=this.currentPage+1;if(t>this.totalPages)return;const{productContainer:e,loadMoreBtn:i}=this.domNodes;this.toggleLoading(!0),fetchSection(this.sectionId,{fromCache:!0,params:{page:t}}).then((t=>{t.querySelectorAll("[data-product-container] .m-product-item").forEach((t=>e.appendChild(t))),this.initProducts()})).catch((t=>{})).finally((()=>{MinimogEvents.emit("ON_PRODUCT_LIST_UPDATED"),this.toggleLoading(!1),this.currentPage=t,t>=this.totalPages&&(i.parentNode.remove(),this.infiniteLoadingObserver&&this.infiniteLoadingObserver.unobserve(i))}))};initProducts=()=>{MinimogTheme.CompareProduct&&MinimogTheme.CompareProduct.setCompareButtonsState(),MinimogTheme.Wishlist&&MinimogTheme.Wishlist.setWishlistButtonsState()};toggleLoading=t=>{const{loadMoreBtn:e}=this.domNodes;if(e){const i=t?"add":"remove";e.classList[i]("m-spinner-loading")}};handleStickyToolbar(){const t=this.domNodes.toolbar,e=t&&t.offsetTop;let i=0;window.addEventListener("scroll",(()=>{if(MinimogTheme.config.mqlMobile){const s=window.scrollY;if(s<=e)return void t.classList.remove("scroll-up","m-collection-toolbar--sticky");t.classList.add("m-collection-toolbar--sticky"),s>t.offsetHeight+e&&s>i&&!t.classList.contains("scroll-down")?(t.classList.remove("scroll-up"),t.classList.add("scroll-down")):s<i&&t.classList.contains("scroll-down")&&(t.classList.remove("scroll-down"),t.classList.add("scroll-up")),i=s}else t.classList.remove("scroll-up","m-collection-toolbar--sticky","scroll-down")}))}}
class Collection {
    constructor() {
        this.selectors = {
            section: ".facest-filters-section",
            toolbar: ".m-collection-toolbar",
            cols: [".m-toolbar--column-switcher button"],
            productContainer: "[data-product-container]",
            loadMoreBtn: "[data-load-more]",
            sidebar: ".m-sidebar",
            sidebarContent: ".m-sidebar--content",
            openSidebar: ".m-sidebar--open",
            closeSidebar: ".m-sidebar--close",
            filtersWrapper: ".m-filter--wrapper"
        };
        console.log(this.selectors,"this.selectorsthis.selectorsthis.selectors")
        this.mobileSortingSelectors = {
            openSorting: ".m-sortby--open",
            closeSorting: ".m-sortby-mobile--close",
            sortingWrapper: ".m-sortby-mobile--wrapper",
            sortingList: ".m-sortby-mobile--content"
        };

        this.sectionId = "";
        this.isDesignMode = MinimogSettings.design_mode;
        this.currentPage = 1;
        this.paginationType = null;
        this.totalPages = 1;
        this.totalProducts = 0;
        this.infiniteLoadingObserver = null;
        this.showColSwitchers = false;
        this.cachedCol = 0;
        this.initialCol = 0;
        this.activeCol = null;

        this.STORAGE_KEY = "gridColumnViews";

        this.MAX_COL_BY_SCREEN_SIZE = {
            mobile: 2,
            tablet: 4,
            desktop: 5
        };

        this.enableFilters = false;
        this.enableSorting = false;
        this.filtersType = "";
        this.filtersPosition = "";
        this.accordions = null;
        this.sideEffectEventsAdded = false;

        // iPhone Safari Safe Bindings
        this.init = this.init.bind(this);
        this.setData = this.setData.bind(this);
        this.initGridView = this.initGridView.bind(this);
        this.initFilters = this.initFilters.bind(this);
        this.initMobileSorting = this.initMobileSorting.bind(this);
        this.initAccordions = this.initAccordions.bind(this);
        this.openSidebarFilter = this.openSidebarFilter.bind(this);
        this.closeSidebarFilter = this.closeSidebarFilter.bind(this);
        this.openMobileSorting = this.openMobileSorting.bind(this);
        this.closeMobileSorting = this.closeMobileSorting.bind(this);
        this.toggleView = this.toggleView.bind(this);
        this.updateViewByScreen = this.updateViewByScreen.bind(this);
        this.loadMoreProducts = this.loadMoreProducts.bind(this);
        this.toggleLoading = this.toggleLoading.bind(this);
        this.handleStickyToolbar = this.handleStickyToolbar.bind(this);
    }

    init() {
        this.domNodes = queryDomNodes(this.selectors);
        this.mbSortingNodes = queryDomNodes(this.mobileSortingSelectors);

        this.setData();
        this.initGridView();
        this.initFilters();
        this.initMobileSorting();
        this.initProducts();

        this.sideEffectEventsAdded = true;

        MinimogEvents.subscribe("ON_PRODUCT_LIST_UPDATED", function () {
            refreshProductReview();
        });

        this.handleStickyToolbar();

        document.addEventListener("matchMobile", this.handleStickyToolbar);
        document.addEventListener("unmatchMobile", this.handleStickyToolbar);
    }

    setData() {
        var section = this.domNodes.section;
        var productContainer = this.domNodes.productContainer;

        if (!section) return;

        this.sectionId = section.dataset.sectionId;
        this.paginationType = section.dataset.paginationType;
        this.totalPages =
            productContainer && productContainer.dataset.totalPages
                ? Number(productContainer.dataset.totalPages)
                : 1;

        this.view = section.dataset.view;

        this.activeCol = null;
        this.currentPage = 1;

        this.initialCol = Number(section.dataset.initialColumn);

        var storageCol = window.localStorage.getItem(this.STORAGE_KEY);

        this.cachedCol = storageCol
            ? Number(storageCol)
            : this.initialCol;

        this.showColSwitchers =
            section.dataset.showColSwitchers === "true";

        this.enableFilters =
            section.dataset.enableFilters === "true";

        this.enableSorting =
            section.dataset.enableSorting === "true";

        this.filtersType = section.dataset.filtersType;
        this.filtersPosition = section.dataset.filtersPosition;
    }

    initGridView() {
        var col = this.isDesignMode
            ? this.initialCol
            : this.cachedCol;

        if (!this.showColSwitchers) {
            if (this.initialCol === 1) {
                col = 2;
            } else {
                col = this.initialCol;
            }
        }

        this.toggleView(col);
        this.updateViewByScreen();

        addEventDelegate({
            selector: this.selectors.cols[0],
            context: this.domNodes.toolbar,
            handler: (t, el) => {
                this.toggleView(Number(el.dataset.column));
            }
        });

        this.initLoadMore();

        if (!this.sideEffectEventsAdded) {
            window.addEventListener(
                "resize",
                debounce(() => {
                    this.updateViewByScreen();
                }, 500)
            );
        }
    }

    initFilters() {
        if (!this.enableFilters) return;

        var sidebar = this.domNodes.sidebar;
        var openSidebar = this.domNodes.openSidebar;
        var closeSidebar = this.domNodes.closeSidebar;

        if (!sidebar || !openSidebar || !closeSidebar) return;

        window.requestAnimationFrame(() => {
            this.initAccordions();
        });

        openSidebar.addEventListener(
            "click",
            this.openSidebarFilter
        );

        closeSidebar.addEventListener(
            "click",
            this.closeSidebarFilter
        );

        sidebar.addEventListener("click", (e) => {
            if (e.target === sidebar) {
                this.closeSidebarFilter();
            }
        });
    }

    initMobileSorting() {
        if (!this.enableSorting) return;

        var openSorting = this.mbSortingNodes.openSorting;
        var closeSorting = this.mbSortingNodes.closeSorting;
        var sortingWrapper = this.mbSortingNodes.sortingWrapper;

        if (!openSorting || !closeSorting || !sortingWrapper) return;

        openSorting.addEventListener(
            "click",
            this.openMobileSorting
        );

        closeSorting.addEventListener(
            "click",
            this.closeMobileSorting
        );

        sortingWrapper.addEventListener("click", (e) => {
            if (e.target === sortingWrapper) {
                this.closeMobileSorting();
            }
        });
    }

    openMobileSorting() {
        var sortingWrapper = this.mbSortingNodes.sortingWrapper;
        var sortingList = this.mbSortingNodes.sortingList;

        if (!sortingWrapper || !sortingList) return;

        sortingWrapper.style.display = "block";

        window.requestAnimationFrame(function () {
            sortingWrapper.style.setProperty(
                "--m-bg-opacity",
                "0.5"
            );

            sortingList.style.setProperty(
                "--m-translate-y",
                "0"
            );
        });
    }

    closeMobileSorting() {
        var sortingWrapper = this.mbSortingNodes.sortingWrapper;
        var sortingList = this.mbSortingNodes.sortingList;

        if (!sortingWrapper || !sortingList) return;

        sortingWrapper.style.setProperty(
            "--m-bg-opacity",
            "0"
        );

        sortingList.style.setProperty(
            "--m-translate-y",
            "100%"
        );

        setTimeout(function () {
            sortingWrapper.style.display = "none";
        }, 300);
    }

    initAccordions() {
        if (this.accordions) {
            this.accordions.destroy();
        }

        var filtersWrapper = this.domNodes.filtersWrapper;

        if (!filtersWrapper) return;

        filtersWrapper.classList.remove("acc-initialized");

        this.accordions = new MinimogLibs.Accordion(
            filtersWrapper,
            {
                presetContentHeight:
                    window.innerWidth > 1280 &&
                    this.filtersPosition !== "fixed",

                callback: function () {
                    filtersWrapper.style.setProperty(
                        "opacity",
                        "1"
                    );
                }
            }
        );
    }

    openSidebarFilter() {
        var sidebar = this.domNodes.sidebar;
        var sidebarContent = this.domNodes.sidebarContent;
        var section = this.domNodes.section;

        if (!sidebar || !sidebarContent || !section) return;

        sidebar.style.display = "block";

        window.requestAnimationFrame(() => {
            sidebar.style.setProperty(
                "--m-bg-opacity",
                "0.5"
            );

            sidebarContent.style.setProperty(
                "--m-translate-x",
                "0"
            );

            if (this.accordions) {
                this.accordions.setContentHeight();
            }
        });

        section.classList.add("sidebar-open");
    }

    closeSidebarFilter() {
        var sidebar = this.domNodes.sidebar;
        var sidebarContent = this.domNodes.sidebarContent;
        var section = this.domNodes.section;

        if (!sidebar || !sidebarContent || !section) return;

        section.classList.remove("sidebar-open");

        if (
            window.innerWidth < 1280 ||
            sidebar.dataset.type === "fixed"
        ) {
            sidebarContent.style.setProperty(
                "--m-translate-x",
                "-100%"
            );

            sidebar.style.removeProperty("--m-bg-opacity");

            setTimeout(function () {
                sidebar.style.removeProperty("display");
            }, 300);
        }
    }

    toggleView(col) {
        if (!this.showColSwitchers) {
            var initial = this.initialCol;

            if (initial === 1) {
                initial = 2;
            }

            if (col === 1) {
                col = initial;
            }

            if (col < 2) {
                col = initial;
            }
        }

        if (!col || this.view === "search") return;

        var cols = this.domNodes.cols;
        var productContainer = this.domNodes.productContainer;

        if (!productContainer) return;

        var imgs =
            productContainer.querySelectorAll("responsive-image");

        if (imgs && imgs.length) {
            imgs.forEach(function (img) {
                if (img.disconnectedCallback) {
                    img.disconnectedCallback();
                }

                if (img.connectedCallback) {
                    img.connectedCallback();
                }
            });
        }

        var prev = this.activeCol || this.initialCol;

        if (this.showColSwitchers) {
            if (cols[prev - 1]) {
                cols[prev - 1].classList.remove("active");
            }

            if (cols[col - 1]) {
                cols[col - 1].classList.add("active");
            }
        }

        productContainer.classList.remove(
            "m-cols-" + prev
        );

        productContainer.classList.add(
            "m-cols-" + col
        );

        window.localStorage.setItem(
            this.STORAGE_KEY,
            col
        );

        this.activeCol = col;
    }

    updateViewByScreen() {
        if (this.activeCol === 1) return;

        var device = this.getDeviceByScreenSize();

        var maxCols =
            this.MAX_COL_BY_SCREEN_SIZE[device];

        if (maxCols < this.activeCol) {
            this.toggleView(maxCols);
        }
    }

    getDeviceByScreenSize() {
        if (window.innerWidth < 768) {
            return "mobile";
        }

        if (window.innerWidth < 1024) {
            return "tablet";
        }

        return "desktop";
    }

    initLoadMore() {
        if (
            this.paginationType === "paginate" ||
            this.totalPages <= 1 ||
            this.view === "search"
        ) {
            return;
        }

        var loadMoreBtn = this.domNodes.loadMoreBtn;

        if (!loadMoreBtn) return;

        loadMoreBtn.addEventListener(
            "click",
            this.loadMoreProducts
        );

        if (
            this.paginationType === "infinite" &&
            "IntersectionObserver" in window
        ) {
            this.infiniteLoadingObserver =
                new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.intersectionRatio === 1) {
                                this.loadMoreProducts();
                            }
                        });
                    },
                    {
                        threshold: 1
                    }
                );

            this.infiniteLoadingObserver.observe(
                loadMoreBtn
            );
        }
    }

    loadMoreProducts() {
        var nextPage = this.currentPage + 1;

        if (nextPage > this.totalPages) return;

        var productContainer =
            this.domNodes.productContainer;

        var loadMoreBtn =
            this.domNodes.loadMoreBtn;

        this.toggleLoading(true);

        fetchSection(this.sectionId, {
            fromCache: true,
            params: {
                page: nextPage
            }
        })
            .then((html) => {
                html
                    .querySelectorAll(
                        "[data-product-container] .m-product-item"
                    )
                    .forEach((item) => {
                        productContainer.appendChild(item);
                    });

                this.initProducts();
            })
            .finally(() => {
                MinimogEvents.emit(
                    "ON_PRODUCT_LIST_UPDATED"
                );

                this.toggleLoading(false);

                this.currentPage = nextPage;

                if (nextPage >= this.totalPages) {
                    loadMoreBtn.parentNode.remove();

                    if (this.infiniteLoadingObserver) {
                        this.infiniteLoadingObserver.unobserve(
                            loadMoreBtn
                        );
                    }
                }
            });
    }

    initProducts() {
        if (
            MinimogTheme.CompareProduct
        ) {
            MinimogTheme.CompareProduct.setCompareButtonsState();
        }

        if (
            MinimogTheme.Wishlist
        ) {
            MinimogTheme.Wishlist.setWishlistButtonsState();
        }
    }

    toggleLoading(loading) {
        var loadMoreBtn =
            this.domNodes.loadMoreBtn;

        if (!loadMoreBtn) return;

        loadMoreBtn.classList[
            loading ? "add" : "remove"
        ]("m-spinner-loading");
    }

    handleStickyToolbar() {
        var toolbar = this.domNodes.toolbar;

        if (!toolbar) return;

        var offset = toolbar.offsetTop;

        var lastScroll = 0;

        window.addEventListener("scroll", function () {
            if (!MinimogTheme.config.mqlMobile) {
                toolbar.classList.remove(
                    "scroll-up",
                    "m-collection-toolbar--sticky",
                    "scroll-down"
                );

                return;
            }

            var sc = window.scrollY;

            if (sc <= offset) {
                toolbar.classList.remove(
                    "scroll-up",
                    "m-collection-toolbar--sticky"
                );

                return;
            }

            toolbar.classList.add(
                "m-collection-toolbar--sticky"
            );

            if (
                sc > toolbar.offsetHeight + offset &&
                sc > lastScroll
            ) {
                toolbar.classList.remove("scroll-up");

                toolbar.classList.add("scroll-down");
            } else if (
                sc < lastScroll &&
                toolbar.classList.contains("scroll-down")
            ) {
                toolbar.classList.remove("scroll-down");

                toolbar.classList.add("scroll-up");
            }

            lastScroll = sc;
        });
    }
}

